<a
  id="trkFeaturedReadLink"
  class="main-container"
  [href]="url()"
  target="_blank"
  [attr.aria-label]="ariaLabel()"
  [class.horizontal-style]="horizontalStyle()">
  <div class="featured-read-image" [class]="styleType()"></div>

  <div class="bottom" [class]="styleType()">
    <div class="font-s-semibold">{{ subtitle() }}</div>
    <h2 class="font-l-semibold">{{ title() }}</h2>

    <a accredible-link id="trkFeaturedReadLinkIn" [href]="url()" target="_blank" [color]="'light'">
      {{ urlLabel() }}
    </a>
  </div>
</a>
